import React, { useEffect, useState } from "react";

const Filter = (props) => {
  const [ready, setReady] = useState(false);
  const [form, setForm] = useState({ filter: {}, offset: 0, limit: 10 });
  let arr = { ...form };
  let initFunction = () => {
    setReady(false);
    if (localStorage.getItem("eventsFilter")) {
      arr.filter = JSON.parse(localStorage.getItem("eventsFilter"));
      setForm(arr);
    }
    setReady(true);
  };

  const saveFilter = (data) => {
    if (data) {
      props.setFilter(data.filter);
      props.getEventsList(1, data.filter);
    } else {
      props.setFilter(form.filter);
      props.getEventsList(1, form.filter);
    }
  };

  useEffect(() => {
    if (!ready) {
      initFunction();
    }
  }, []);

  const leaveClick = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      localStorage.setItem("eventsFilter", JSON.stringify(form.filter));
      saveFilter();
      props.setModal(false);
    }
  };
  const resetClick = () => {
    arr = { filter: [] };
    setForm(arr);
    localStorage.removeItem("eventsFilter");
    saveFilter(arr);
  };
  const dateChange = (e) => {
    e.preventDefault();
    arr = { ...form };

    arr.filter[e.target.accessKey] = [];
    arr.filter[e.target.accessKey].push(e.target.value);
    setForm(arr);
  };

  return (
    <div className="apFilterContainer" onBlur={leaveClick} tabIndex="0">
      <div className="apFilterHeader">
        <h4>Параметри фільтра</h4>
        <div style={{ display: "flex" }}>
          <button
            style={{ marginRight: "20px" }}
            className="secondarySmallRoundedButtonTextDefault"
            onClick={resetClick}
          >
            Скинути
          </button>
          <button
            className="secondarySmallRoundedButtonTextDefault"
            onClick={leaveClick}
          >
            OK
          </button>
        </div>
      </div>
      <div className="apFilterGroupBlock">
        <span>Дата створення з</span>
        <div className="apFilterButtonsBlock">
          <input
            id="createdFrom"
            accessKey="createdFrom"
            type="date"
            onChange={dateChange}
          />
        </div>
      </div>
      <div className="apFilterGroupBlock">
        <span>Дата по</span>
        <div className="apFilterButtonsBlock">
          <input
            id="createdTo"
            accessKey="createdTo"
            type="date"
            onChange={dateChange}
          />
        </div>
      </div>
      <div className="apFilterGroupBlock">
        <span>Дата початку з</span>
        <div className="apFilterButtonsBlock">
          <input
            id="startsFrom"
            accessKey="startsFrom"
            type="date"
            onChange={dateChange}
          />
        </div>
      </div>
      <div className="apFilterGroupBlock">
        <span>Дата початку по</span>
        <div className="apFilterButtonsBlock">
          <input
            id="startsTo"
            accessKey="startsTo"
            type="date"
            onChange={dateChange}
          />
        </div>
      </div>
      <div className="apFilterGroupBlock">
        <span>Дата завершення з</span>
        <div className="apFilterButtonsBlock">
          <input
            id="finishesFrom"
            accessKey="finishesFrom"
            type="date"
            onChange={dateChange}
          />
        </div>
      </div>
      <div className="apFilterGroupBlock">
        <span>Дата завершення по</span>
        <div className="apFilterButtonsBlock">
          <input
            id="finishesTo"
            accessKey="finishesTo"
            type="date"
            onChange={dateChange}
          />
        </div>
      </div>
    </div>
  );
};

export default Filter;
